<div class="skippy visually-hidden-focusable">
  <div class="container-fluid">
    <a href="#main" class="d-inline-flex p-2 m-1">Skip to Main Content</a>
  </div>
</div>
<header class="d-print-none">
  <nav class="navbar navbar-expand-lg navbar-light" [class]="getBackgroundClass()" aria-label="Main Navigation">
    <div class="container-fluid">
      <a class="navbar-brand" [routerLink]="[homeUrl()]">
        <img
          src="/assets/azde-seal-blank.png"
          alt="AZDE Logo"
          title="Arizona Department of Education"
          width="40"
          height="40"
        />
      </a>
      <div class="me-5">
        <div class="text-body-emphasis">
          {{ currentEdOrgName }} ({{ currentEdOrgId }})
          @if (canChangeEdOrg) {
            <i
              class="bi bi-arrow-left-right ms-2 clickable"
              certTooltip="Click here to change your EdOrg"
              (click)="onChangeEdOrg($event)"
            ></i>
          }
        </div>
        <div class="text-body-emphasis">School Year {{ fiscalYearDescription }}</div>
      </div>

      @if (dataLoaded() && showEducatorSearch()) {
        <button
          type="button"
          class="btn btn-outline-primary"
          requiresPolicy="canSearchEducators"
          (click)="openEducatorSearch()"
        >
          <i class="search-icon me-2"></i>{{ getEducatorSearchLabel() }}
        </button>
      }

      <button
        class="navbar-toggler btn-sidebar"
        type="button"
        data-toggle="collapse"
        data-target=".navbar-collapse"
        aria-label="Toggle Main Navigation"
        [attr.aria-expanded]="isExpanded"
        (click)="toggle()"
      >
        <i class="bi bi-list"></i>
      </button>

      <div class="navbar-collapse collapse d-lg-inline-flex justify-content-end" [ngClass]="{ show: isExpanded }">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item dropdown my-auto">
            @if (portalRoutes().length > 1) {
              <a
                class="nav-link dropdown-toggle"
                [routerLink]="[homeUrl()]"
                [routerLinkActive]="['link-active']"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                >Home</a
              >
              <ul class="dropdown-menu">
                @for (portalRoute of portalRoutes(); track portalRoute.portal) {
                  <li>
                    <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="[portalRoute.route]">{{
                      portalRoute.description
                    }}</a>
                  </li>
                }
              </ul>
            } @else {
              <a
                class="nav-link"
                [routerLink]="[homeUrl()]"
                [routerLinkActive]="['link-active']"
                role="button"
                aria-expanded="false"
                >Home</a
              >
            }
          </li>
        </ul>

        @switch (currentRouteType()) {
          @case (routeTypes.Cert) {
            <cert-cert-nav-menu />
          }
          @case (routeTypes.Lea) {
            <cert-lea-nav-menu />
          }
          @case (routeTypes.Lea2) {
            <cert-lea2-nav-menu />
          }
          @case (routeTypes.Epp) {
            <cert-epp-nav-menu />
          }
        }

        @if (showAdminDropdown) {
          <ul class="navbar-nav flex-grow">
            <li class="nav-item dropdown my-auto">
              <a
                class="nav-link dropdown-toggle"
                [routerLink]="['/cert']"
                [routerLinkActive]="['link-active']"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                >Admin</a
              >

              <ul class="dropdown-menu dropdown-menu-left">
                <li [routerLinkActive]="['link-active']" requiresPolicy="canMapRolePermissions">
                  <a class="dropdown-item" [routerLink]="['/cert/admin']">Manage Role Permissions</a>
                </li>
                <li [routerLinkActive]="['link-active']" requiresPolicy="canViewRolePermissions">
                  <a class="dropdown-item" [routerLink]="['/cert/admin/view-role-permissions']"
                    >View Role Permissions</a
                  >
                </li>
                <li [routerLinkActive]="['link-active']" requiresPolicy="canManageHangfire">
                  <a class="dropdown-item" href="/hangfire">Manage Background Jobs</a>
                </li>
                <li [routerLinkActive]="['link-active']" requiresPolicy="canManageHelpObjects">
                  <a class="dropdown-item" [routerLink]="['/cert/admin/help']">Manage Help Objects</a>
                </li>
                <li [routerLinkActive]="['link-active']" requiresPolicy="canManagePageAlerts">
                  <a class="dropdown-item" [routerLink]="['/cert/admin/page-alerts']">Manage Page Alerts</a>
                </li>
                <li [routerLinkActive]="['link-active']" requiresPolicy="canMapRolePermissions">
                  <a class="dropdown-item" [routerLink]="['/cert/admin/features']">Feature State</a>
                </li>
                @if (credentialConfigurationFeatureEnabled$ | async) {
                  <li [routerLinkActive]="['link-active']" requiresPolicy="canViewAdminConfigurations">
                    <a class="dropdown-item" [routerLink]="['/cert/admin/configuration']">Configuration</a>
                  </li>
                }
                @if (mergeEducatorsFeatureEnabled$ | async) {
                  <li [routerLinkActive]="['link-active']" requiresPolicy="canMergeEducators">
                    <a class="dropdown-item" [routerLink]="['/cert/admin/merge']">Merge Educators</a>
                  </li>
                }

                @if (evalQualPathToolFeatureEnabled$ | async) {
                  <li *componentRequiresPolicy="'canManageEvaluations'">
                    <a
                      class="dropdown-item"
                      [routerLinkActive]="['link-active']"
                      [routerLink]="['/cert/admin/evaluation-tool']"
                      >Evaluation Tool</a
                    >
                  </li>
                  <li *componentRequiresPolicy="'canManageEvaluations'">
                    <a
                      class="dropdown-item"
                      [routerLinkActive]="['link-active']"
                      [routerLink]="['/cert/admin/qualification-path-tool']"
                      >Qualification Path Tool</a
                    >
                  </li>
                }
                @if ((yearTransitionFeatureEnabled$ | async) || (surveyFeatureEnabled$ | async)) {
                  <li>
                    <a
                      class="dropdown-item"
                      [routerLinkActive]="['link-active']"
                      [routerLink]="['/cert/admin/lea-admin']"
                      >Lea Administration</a
                    >
                  </li>
                }
                @if (vouchersEnabled$ | async) {
                  <li [routerLinkActive]="['link-active']" requiresPolicy="canManageVoucherPrograms">
                    <a class="dropdown-item" [routerLink]="['/cert/admin/vouchers']">Manage Vouchers</a>
                  </li>
                  <li [routerLinkActive]="['link-active']" requiresPolicy="canViewAdminReports">
                    <a class="dropdown-item" [routerLink]="['/cert/admin/reports']">Reports</a>
                  </li>
                }
              </ul>
            </li>
          </ul>
        }

        <ul class="navbar-nav flex-grow">
          <li class="nav-item dropdown my-auto">
            <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false"
              ><i class="bi bi-person-circle"></i></a
            ><span class="visually-hidden">User Preferences</span>
            <ul class="dropdown-menu dropdown-menu-left">
              @if (canChangeEdOrg) {
                <li>
                  <a class="dropdown-item clickable" href="#" (click)="onChangeEdOrg($event)">Change Organization</a>
                </li>
              }
              @if (obscurityFeatureEnabled()) {
                <li>
                  <a class="dropdown-item clickable" href="#" (click)="onToggleObscurity($event)"
                    >Toggle Sensitive Data Obscurity</a
                  >
                </li>
              }
              <li><a class="dropdown-item clickable" href="#" (click)="onViewProfile($event)">Profile</a></li>
              <li><a class="dropdown-item clickable" href="#" (click)="logout($event)">Logout</a></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
